import React from "react";

import clsx from "clsx";

import { AddTileModal } from "@features/overview-v2/components";
import { useDisclosure } from "@hooks/use-disclosure";

import { OverviewGrid } from "./overview-grid";

const AddNewTileButton = () => {
  const [
    addTileModalOpened,
    { open: openNewTileModal, close: closeNewTileModal },
  ] = useDisclosure(false);

  return (
    <>
      <button
        className={clsx(
          "w-full font-bold text-sm text-v2-action border border-dashed border-v2-focus",
          "rounded-lg flex items-center justify-center my-3 py-7",
          "hover:bg-v2-highlight-information hover:border-solid hover:border-v2-information hover:text-v2-action",
        )}
        onClick={() => {
          openNewTileModal();
        }}
      >
        <i className="fa-solid fa-sharp fa-plus mr-2"></i>
        ADD TILE
      </button>
      {addTileModalOpened && (
        <AddTileModal
          isOpen={addTileModalOpened}
          onClose={() => closeNewTileModal()}
        />
      )}
    </>
  );
};

export const OverviewGridView = (props: { className?: string }) => (
  <div
    {...props}
    className={clsx(
      "relative w-[calc(100%-24px)] max-w-[100%] flex flex-col gap-1",
      props.className,
    )}
  >
    <OverviewGrid />
    <div className="pr-6">
      <AddNewTileButton />
    </div>
  </div>
);
